import React from 'react';
import ReactDOM from 'react-dom';
import firebase from 'firebase';
import hotjar from './vendor/hotjar';
import smoothScroll from 'smoothscroll-polyfill';

import './index.css';
import App from './components/App';
import registerServiceWorker from './registerServiceWorker';

import {
  HOTJAR_ID,
  HOTJAR_VERSION,
  FIREBASE_DEV,
  FIREBASE_PROD,
} from './lib/constants';

smoothScroll.polyfill();
hotjar.initialize(HOTJAR_ID, HOTJAR_VERSION);

const config = window.location.href.match('argofrienddate') ? FIREBASE_PROD : FIREBASE_DEV;
firebase.initializeApp(config);

ReactDOM.render(<App />, document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js